import type { TextProps } from '@chakra-ui/react';
import { Text } from '@chakra-ui/react';
import { useMemo } from 'react';

export const FoldDecimal = ({
  value,
  prependZeroCount = 3,
  ignoreNotPure = false,
  ...restProps
}: {
  value: string;
  prependZeroCount?: number;
  ignoreNotPure?: boolean;
} & Omit<TextProps, 'value'>) => {
  const child = useMemo(() => {
    const info = calcFoldText(value, prependZeroCount, ignoreNotPure);
    if (!info) return value;
    const [count, s, e] = info;
    return (
      <>
        {value.slice(0, s)}0
        <Text
          as="span"
          display="inline-block"
          transform="scale(.7)"
          transformOrigin="45% 80%"
        >
          {count}
        </Text>
        {value.slice(e)}
      </>
    );
  }, [value, prependZeroCount, ignoreNotPure]);
  return <Text {...restProps}>{child}</Text>;
};

const calcFoldText = (
  value: string,
  prependZeroCount: number,
  ignoreNotPure: boolean,
) => {
  if (!value.replace(/,/g, '').match(/^[0-9]*\.[0-9]+$/)) return;
  const [int, dec] = value.split('.');
  if (ignoreNotPure && +int > 0) return;
  let i = 0;
  for (; i < dec.length; i += 1) if (dec[i] !== '0') break;
  if (i < prependZeroCount) return;
  return [i, int.length + 1, int.length + 1 + i];
};
